import { makeInt64DataField, makeStringDataField } from './DataFieldHelper';
export var Error = {
    /**
     * Gets data fields for the Error Contract
     * @param contract - The object containing data fields pertaining to the Error Contract
     */
    getFields: function (contract) {
        var instanceName = 'Error';
        var dataFields = [];
        dataFields.push(makeStringDataField("".concat(instanceName, ".ErrorGroup"), contract.errorGroup));
        dataFields.push(makeInt64DataField("".concat(instanceName, ".Tag"), contract.tag));
        if (contract.code !== undefined) {
            dataFields.push(makeInt64DataField("".concat(instanceName, ".Code"), contract.code));
        }
        if (contract.id !== undefined) {
            dataFields.push(makeInt64DataField("".concat(instanceName, ".Id"), contract.id));
        }
        if (contract.count !== undefined) {
            dataFields.push(makeInt64DataField("".concat(instanceName, ".Count"), contract.count));
        }
        return dataFields;
    }
}; // Error
//# sourceMappingURL=InternalContracts.js.map